module.exports = __webpack_public_path__ + "img/carret-bottom-gray.58929459.svg";